import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import GitHubIcon from "@mui/icons-material/GitHub";
import Grid from "@mui/material/Grid";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme";
import Footer from "./components/Footer";
import HULogo from "./assets/logos/HULogo";
import HomeButton from "./components/HomeButton";
import VerticalNavMenu from "./components/VerticalNavMenu";
import SkillSelect from "./components/SkillSelect";
import { skillNames } from "./utils";

export default function App() {

  // Module can also be selected via url parameter: /?fysio or /?module=fysio; Default is student module
  const queryParameters = new URLSearchParams(window.location.search)
  let defaultSkill = skillNames()[0];
  switch (queryParameters.get("module")) {
    case 'ontlokken':
      defaultSkill = skillNames()[1];
      break;

    case 'erkennen':
      defaultSkill = skillNames()[2];
      break;

    case 'verkennen':
      defaultSkill = skillNames()[3];
      break;


    default:
      defaultSkill = skillNames()[0];
      break;
  }

  const [selectedSkill, setSelectedSkill] = React.useState(defaultSkill);

  // activeStep holds the page.nr
  const [activeStep, setActiveStep] = React.useState(0);

  const switchSkill = (newSkillId) => {
    setActiveStep(0);
    setSelectedSkill(newSkillId);
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          bgcolor: "#f6f6f6", // original color grey: #f2f2f2
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <AppBar
          position="static"
          color="inherit"
          elevation={0}
          sx={{
            position: "relative",
            borderBottom: (t) => `2px solid ${t.palette.divider}`,
            padding: "1.5px 0",
          }}
        >
          <Toolbar>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <Grid item>
                <Button href="https://www.hu.nl/">
                  <HULogo />
                </Button>
                <HomeButton />
              </Grid>
              <Grid item>
                <SkillSelect skillId={selectedSkill} switchSkill={switchSkill} />
                <Button
                  style={{ textTransform: "none" }}
                  variant="text"
                  sx={{ mx: 1.5 }}
                  startIcon={<GitHubIcon />}
                  href="https://github.com/uashogeschoolutrecht/CoPain"
                  color="inherit"
                >
                  GitHub
                </Button>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
        <Container component="main" maxWidth="lg" sx={{ mb: 4 }}>
          <Box component="form" sx={{ mt: 1 }}>
            <VerticalNavMenu skillId={selectedSkill} activeStep={activeStep} setActiveStep={setActiveStep} />
          </Box>
        </Container>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}
